export const getFingerPrint = <T extends boolean>(shouldSerialize?: T): T extends true ? string : any => {
  const fp = {
    userAgent: navigator.userAgent,
    language: navigator.language,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    screenResolution: `${window.screen.width}x${window.screen.height}`,
  } as any;

  return shouldSerialize ? JSON.stringify(fp) : fp;
}; 